<template>
    
    <div>
        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Blocks</h2>

        <div class="text-center">
            <div class="blocks-action-bar-inline">
                <div class="device-selector--large inline-style">

                    <i class="fas fa-desktop active" data-device="desktopSettings" v-b-tooltip.hover.top title="Desktop" @click="switchDevice"></i>
                    <i class="fas fa-tablet-alt" data-device="tabletSettings" v-b-tooltip.hover.top title="Tablet" @click="switchDevice"></i>
                    <i class="fas fa-mobile-alt" data-device="mobileSettings" v-b-tooltip.hover.top title="Phone" @click="switchDevice"></i>

                </div>
                
                <b-button v-b-tooltip.hover.top title="Add child block" variant="primary" class="addChildBlock-btn" size="sm" @click="addToChildArray">
                    +</b-button>
            </div>
        </div>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <div v-if="settingsFromWeebly.settings.parentFullWidth" class="bundle-element-setfullwidth-guide"></div>
            <div 
            
            :class="[(settingsFromWeebly.settings.parentFullWidth 
            ? 'blocks-flex-parent-wrap bundle-element-setfullwidth' 
            : 'blocks-flex-parent-wrap'),(settingsFromWeebly.settings.useParallax && settingsFromWeebly.settings.parentFullWidth && (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? 'jarallax':''), (settingsFromWeebly.settings.backgroundVideo && settingsFromWeebly.settings.parentFullWidth ? 'block-with-video-bg': '')]"

            :data-speed="settingsFromWeebly.settings.useParallax && settingsFromWeebly.settings.parentFullWidth && (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? settingsFromWeebly.settings.parallaxSpeed : null"

            :data-img-position="settingsFromWeebly.settings.useParallax && 
            settingsFromWeebly.settings.parentFullWidth && 
            (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? settingsFromWeebly.settings.xAxisPosition +' '+settingsFromWeebly.settings.yAxisPosition : null"

            :data-jarallax="settingsFromWeebly.settings.useParallax && settingsFromWeebly.settings.parentFullWidth && 
            (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? '': null"

            :data-jarallax-video="settingsFromWeebly.settings.backgroundVideo && settingsFromWeebly.settings.parentFullWidth ? settingsFromWeebly.settings.backgroundVideoUrl : null"

             >
                <draggable 
                :id="settingsFromWeebly.settings.flexParentId" 
                class="blocks-flex-parent" 
                :class="[(settingsFromWeebly.settings.useParallax && !settingsFromWeebly.settings.parentFullWidth && (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? 'jarallax':''), (settingsFromWeebly.settings.backgroundVideo && !settingsFromWeebly.settings.parentFullWidth ? 'block-with-video-bg': '')]"

                :data-speed="settingsFromWeebly.settings.useParallax && !settingsFromWeebly.settings.parentFullWidth && (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? settingsFromWeebly.settings.parallaxSpeed : null"
                :data-img-position="settingsFromWeebly.settings.useParallax && 
                !settingsFromWeebly.settings.parentFullWidth && 
                (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? settingsFromWeebly.settings.xAxisPosition +' '+settingsFromWeebly.settings.yAxisPosition : null"
                :data-jarallax="settingsFromWeebly.settings.useParallax && !settingsFromWeebly.settings.parentFullWidth && 
                (settingsFromWeebly.settings.backgroundImage || settingsFromWeebly.settings.backgroundVideo) ? '': null"
                :data-jarallax-video="settingsFromWeebly.settings.backgroundVideo && !settingsFromWeebly.settings.parentFullWidth ? settingsFromWeebly.settings.backgroundVideoUrl : null"

 

                v-model="childBlocksArray" 
                ghost-class="ghost-block" 
                handle=".block-drag-handle"
                >
                    
                    <BlocksChild 
                        v-for="(childStyle, index) in childBlocksArray" :key="index" 
                        :id="childStyle.blockId" class="block-child" 
                        :settingsToShow="childStyle.blockId" 
                        :childBlock="childStyle"
                        :arrayIndex="index"
                        :class="[(childStyle.useParallax && (childStyle.backgroundImageChild || childStyle.backgroundVideoChild) ? 'jarallax':''), (childStyle.backgroundVideoChild ? 'block-with-video-bg': ''), (childStyle.hideOnDesktop ? 'hide-child-block-desktop' : ''), (childStyle.hideOnTablet ? 'hide-child-block-tablet' : ''), (childStyle.hideOnPhone ? 'hide-child-block-phone' : '')]"
                        :data-speed="childStyle.useParallax && (childStyle.backgroundImageChild || childStyle.backgroundVideoChild) ? childStyle.parallaxSpeed : null"
                        :data-img-position="childStyle.useParallax && (childStyle.backgroundImageChild || childStyle.backgroundVideoChild) ? childStyle.xAxisPosition +' '+childStyle.yAxisPosition : null"
                        :data-jarallax="childStyle.useParallax && (childStyle.backgroundImageChild || childStyle.backgroundVideoChild) ? '': null"
                        :data-jarallax-video="childStyle.backgroundVideoChild ? childStyle.backgroundVideoUrl : null"

                        
                        />
                </draggable>
            </div>

            <vstyle>
                .bundle-element-setfullwidth {
                    opacity: 0;
                    position: relative;
                }
                .blocks-flex-parent {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-wrap: wrap;
                        flex-wrap: wrap;
                    position: relative;
                    margin: 0 auto;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                }
                .blocks-flex-parent-wrap {
                    margin: 0 auto;

                    {{settingsFromWeebly.settings.parentFullWidth && !settingsFromWeebly.settings.useIndividualBorderRadius ? 'border-radius:'+settingsFromWeebly.settings.borderRadiusGeneral+'px;' : ''}}

                    {{ settingsFromWeebly.settings.parentFullWidth && settingsFromWeebly.settings.useIndividualBorderRadius ?
                    'border-top-left-radius:' + settingsFromWeebly.settings.borderTopLeftRadius+'px;' 
                    +'border-top-right-radius:' + settingsFromWeebly.settings.borderTopRightRadius+'px;'
                    +'border-bottom-right-radius:' + settingsFromWeebly.settings.borderBottomRightRadius+'px;'
                    +'border-bottom-left-radius:' + settingsFromWeebly.settings.borderBottomLeftRadius+'px;'
                    : ''}}

                    {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent && settingsFromWeebly.settings.parentFullWidth ?
                    'border-top-color:' + settingsFromWeebly.settings.borderTopColorParent+';' 
                    +'border-top-style:' + settingsFromWeebly.settings.borderTopStyleParent +';'
                    +'border-top-width:' + settingsFromWeebly.settings.borderTopWidthParent +'px;'

                    +'border-right-color:' + settingsFromWeebly.settings.borderRightColorParent +';'
                    +'border-right-style:' + settingsFromWeebly.settings.borderRightStyleParent +';'
                    +'border-right-width:' + settingsFromWeebly.settings.borderRightWidthParent+'px;'

                    +'border-bottom-color:'+ settingsFromWeebly.settings.borderBottomColorParent +';'
                    +'border-bottom-style: '+settingsFromWeebly.settings.borderBottomStyleParent+';'
                    +'border-bottom-width:' +settingsFromWeebly.settings.borderBottomWidthParent+'px;'

                    +'border-left-color:' +settingsFromWeebly.settings.borderLeftColorParent+';'
                    +'border-left-style:' +settingsFromWeebly.settings.borderLeftStyleParent+';'
                    +'border-left-width:' +settingsFromWeebly.settings.borderLeftWidthParent+'px;'
                    : ''}}

                    {{ !settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent && settingsFromWeebly.settings.parentFullWidth ? 'border:' + settingsFromWeebly.settings.parentBorderWidth+'px ' + settingsFromWeebly.settings.parentBorderType+' ' + settingsFromWeebly.settings.parentBorderColor+';' : '' }}

                    {{settingsFromWeebly.settings.backgroundColor && settingsFromWeebly.settings.parentFullWidth ? 'background: '+settingsFromWeebly.settings.parentBackground+';':''}}
                    {{settingsFromWeebly.settings.backgroundImage && settingsFromWeebly.settings.parentFullWidth ? 'background: url('+settingsFromWeebly.settings.backgroundImageSet+')'+' '+ settingsFromWeebly.settings.xAxisPosition+' '+settingsFromWeebly.settings.yAxisPosition+'/cover;':''}}
                }
                #{{settingsFromWeebly.settings.flexParentId}}{
                    <!-- background: {{settingsFromWeebly.settings.parentBackground}}; -->
                    padding: {{settingsFromWeebly.settings.parentVerticalPadding}}px {{settingsFromWeebly.settings.parentHorizontalPadding}}px;
                    width: 100%;
                    max-width: {{settingsFromWeebly.settings.parentMaxWidth}}px;

                    {{settingsFromWeebly.settings.backgroundColor && !settingsFromWeebly.settings.parentFullWidth ? 'background: '+settingsFromWeebly.settings.parentBackground+';':''}}
                    {{settingsFromWeebly.settings.backgroundImage && !settingsFromWeebly.settings.parentFullWidth ? 'background: url('+settingsFromWeebly.settings.backgroundImageSet+')'+' '+ settingsFromWeebly.settings.xAxisPosition+' '+settingsFromWeebly.settings.yAxisPosition+'/cover;':''}}
                   
                    {{!settingsFromWeebly.settings.parentFullWidth && !settingsFromWeebly.settings.useIndividualBorderRadius ? 'border-radius:'+settingsFromWeebly.settings.borderRadiusGeneral+'px;' : ''}}

                    {{ !settingsFromWeebly.settings.parentFullWidth && settingsFromWeebly.settings.useIndividualBorderRadius ?
                    'border-top-left-radius:' + settingsFromWeebly.settings.borderTopLeftRadius+'px;' 
                    +'border-top-right-radius:' + settingsFromWeebly.settings.borderTopRightRadius+'px;'
                    +'border-bottom-right-radius:' + settingsFromWeebly.settings.borderBottomRightRadius+'px;'
                    +'border-bottom-left-radius:' + settingsFromWeebly.settings.borderBottomLeftRadius+'px;'
                    : ''}}

                    {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent && !settingsFromWeebly.settings.parentFullWidth ?
                    'border-top-color:' + settingsFromWeebly.settings.borderTopColorParent+';' 
                    +'border-top-style:' + settingsFromWeebly.settings.borderTopStyleParent +';'
                    +'border-top-width:' + settingsFromWeebly.settings.borderTopWidthParent +'px;'

                    +'border-right-color:' + settingsFromWeebly.settings.borderRightColorParent +';'
                    +'border-right-style:' + settingsFromWeebly.settings.borderRightStyleParent +';'
                    +'border-right-width:' + settingsFromWeebly.settings.borderRightWidthParent+'px;'

                    +'border-bottom-color:'+ settingsFromWeebly.settings.borderBottomColorParent +';'
                    +'border-bottom-style: '+settingsFromWeebly.settings.borderBottomStyleParent+';'
                    +'border-bottom-width:' +settingsFromWeebly.settings.borderBottomWidthParent+'px;'

                    +'border-left-color:' +settingsFromWeebly.settings.borderLeftColorParent+';'
                    +'border-left-style:' +settingsFromWeebly.settings.borderLeftStyleParent+';'
                    +'border-left-width:' +settingsFromWeebly.settings.borderLeftWidthParent+'px;'
                    : ''}}

                    {{ !settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent && !settingsFromWeebly.settings.parentFullWidth ? 'border:' + settingsFromWeebly.settings.parentBorderWidth+'px ' + settingsFromWeebly.settings.parentBorderType+' ' + settingsFromWeebly.settings.parentBorderColor+';' : '' }}

                    {{!settingsFromWeebly.settings.parentFullWidth ? 'max-width:'+settingsFromWeebly.settings.parentMaxWidth+'px;': ''}}
                }
                .block-child {
                    min-height: 100px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    position: relative;
                }
                @media(max-width: 768px) {
                    #{{settingsFromWeebly.settings.flexParentId}}{
                        padding: {{settingsFromWeebly.settings.verticalPadTabletParent || settingsFromWeebly.settings.parentVerticalPadding}}px {{settingsFromWeebly.settings.horizontalPadTabletParent || settingsFromWeebly.settings.parentHorizontalPadding}}px;
                    }

                    .blocks-flex-parent-wrap {
                        {{!settingsFromWeebly.settings.useIndividualBorder &&  settingsFromWeebly.settings.borderGeneralWidthTabletParent ? 'border-width:'+settingsFromWeebly.settings.borderGeneralWidthTabletParent+'px;':''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderTopWidthTabletParent ?
                        'border-top-width:' + settingsFromWeebly.settings.borderTopWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderRightWidthTabletParent ?
                        'border-right-width:' + settingsFromWeebly.settings.borderRightWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderBottomWidthTabletParent ?
                        'border-bottom-width:' + settingsFromWeebly.settings.borderBottomWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderLeftWidthTabletParent ?
                        'border-left-width:' + settingsFromWeebly.settings.borderLeftWidthTabletParent +'px;' : ''}}
                    }
                    
                }
                @media(max-width: 576px) {
                    #{{settingsFromWeebly.settings.flexParentId}}{
                        padding: {{settingsFromWeebly.settings.verticalPadPhoneParent || settingsFromWeebly.settings.verticalPadTabletParent || settingsFromWeebly.settings.parentVerticalPadding}}px {{settingsFromWeebly.settings.horizontalPadPhoneParent || settingsFromWeebly.settings.horizontalPadTabletParent || settingsFromWeebly.settings.parentHorizontalPadding}}px;
                    }
                    .blocks-flex-parent-wrap {
                        {{!settingsFromWeebly.settings.useIndividualBorder &&  settingsFromWeebly.settings.borderGeneralWidthPhoneParent ? 'border-width:'+settingsFromWeebly.settings.borderGeneralWidthPhoneParent+'px;':''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderTopWidthPhoneParent ?
                        'border-top-width:' + settingsFromWeebly.settings.borderTopWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderRightWidthPhoneParent ?
                        'border-right-width:' + settingsFromWeebly.settings.borderRightWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderBottomWidthPhoneParent ?
                        'border-bottom-width:' + settingsFromWeebly.settings.borderBottomWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderLeftWidthPhoneParent ?
                        'border-left-width:' + settingsFromWeebly.settings.borderLeftWidthPhoneParent +'px;' : ''}}
                    }
                }
            </vstyle>


            <vstyle v-for="(childStyle, index) in childBlocksArray" :key="index">

                #{{childStyle.blockId}}{
                    width: 100%;
                    max-width: {{childStyle.maxWidthDesktop}}%;

                    {{childStyle.backgroundColorChild ? 'background: '+childStyle.childBackground+';':''}}
                    {{childStyle.backgroundImageChild ? 'background: url('+childStyle.backgroundImageChildSet+')'+' '+ childStyle.xAxisPosition+' '+childStyle.yAxisPosition+'/cover;':''}}

                    padding: {{childStyle.verticalPad}}px {{childStyle.horizontalPad}}px;
                    
                    {{ childStyle.useIndividualBorder ?
                    'border-top-color:' + childStyle.borderTopColor+';' 
                    +'border-top-style:' + childStyle.borderTopStyle +';'
                    +'border-top-width:' + childStyle.borderTopWidth +'px;'

                    +'border-right-color:' + childStyle.borderRightColor +';'
                    +'border-right-style:' + childStyle.borderRightStyle +';'
                    +'border-right-width:' + childStyle.borderRightWidth+'px;'

                    +'border-bottom-color:'+ childStyle.borderBottomColor +';'
                    +'border-bottom-style: '+childStyle.borderBottomStyle+';'
                    +'border-bottom-width:' +childStyle.borderBottomWidth+'px;'

                    +'border-left-color:' +childStyle.borderLeftColor+';'
                    +'border-left-style:' +childStyle.borderLeftStyle+';'
                    +'border-left-width:' +childStyle.borderLeftWidth+'px;'
                    : ''}}

                    {{ !childStyle.useIndividualBorder ? 'border:' + childStyle.borderGeneralWidth+'px ' + childStyle.borderGeneralStyle+' ' + childStyle.borderGeneralColor+';' : '' }}

                    {{!childStyle.useIndividualBorderRadius ? 'border-radius:'+childStyle.borderRadiusGeneral+'px;' : ''}}

                    {{ childStyle.useIndividualBorderRadius ?
                    'border-top-left-radius:' + childStyle.borderTopLeftRadius+'px;' 
                    +'border-top-right-radius:' + childStyle.borderTopRightRadius+'px;'
                    +'border-bottom-right-radius:' + childStyle.borderBottomRightRadius+'px;'
                    +'border-bottom-left-radius:' + childStyle.borderBottomLeftRadius+'px;'
                    : ''}}

                }

                @media(max-width: 768px) {
                    #{{childStyle.blockId}}{
                        max-width: {{childStyle.maxWidthTablet || childStyle.maxWidthDesktop}}%;
                        padding: {{childStyle.verticalPadTablet || childStyle.verticalPad}}px {{childStyle.horizontalPadTablet || childStyle.horizontalPad}}px;
                        {{childStyle.borderGeneralWidthTablet ? 'border-width:'+childStyle.borderGeneralWidthTablet+'px;':''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderTopWidthTablet ?
                        'border-top-width:' + childStyle.borderTopWidthTablet +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderRightWidthTablet ?
                        'border-right-width:' + childStyle.borderRightWidthTablet +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderBottomWidthTablet ?
                        'border-bottom-width:' + childStyle.borderBottomWidthTablet +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderLeftWidthTablet ?
                        'border-left-width:' + childStyle.borderLeftWidthTablet +'px;' : ''}}
                    }
                }

                @media(max-width: 576px) {
                    #{{childStyle.blockId}}{
                        max-width: {{childStyle.maxWidthPhone || childStyle.maxWidthTablet || childStyle.maxWidthDesktop}}%;
                        padding: {{childStyle.verticalPadPhone || childStyle.verticalPadTablet || childStyle.verticalPad}}px {{childStyle.horizontalPadPhone || childStyle.horizontalPadTablet || childStyle.horizontalPad}}px;
                        {{childStyle.borderGeneralWidthPhone ? 'border-width:'+childStyle.borderGeneralWidthPhone+'px;':''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderTopWidthPhone ?
                        'border-top-width:' + childStyle.borderTopWidthPhone +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderRightWidthPhone ?
                        'border-right-width:' + childStyle.borderRightWidthPhone +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderBottomWidthPhone ?
                        'border-bottom-width:' + childStyle.borderBottomWidthPhone +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderLeftWidthPhone ?
                        'border-left-width:' + childStyle.borderLeftWidthPhone +'px;' : ''}}
                    }
                    .hide-child-block-phone {
                        display: none;
                    }
                }

                @media(min-width: 576px) and (max-width: 768px) {
                    .hide-child-block-tablet {
                        display: none;
                    }
                }

                @media(min-width: 768px) {
                    .hide-child-block-desktop {
                        display: none;
                    }
                }
                

            </vstyle>
            <div v-if="deviceStylesSetttings.desktopStyles">
                <vstyle>
                    .hide-child-block-desktop::before {
                        font-family: "Font Awesome 5 Free";
                        content: "\f070";
                        font-size: 12px;
                        line-height: 40px;
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        text-align: center;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        font-weight: 400;
                        border: 1px solid #E7003E;
                        color: #E7003E;
                        background: #fff;
                    }
                </vstyle>
            </div>
            <div v-if="deviceStylesSetttings.tabletStyles">
                <vstyle v-for="(childStyle, index) in childBlocksArray" :key="index">
                    #{{settingsFromWeebly.settings.flexParentId}}{
                        padding: {{settingsFromWeebly.settings.verticalPadTabletParent || settingsFromWeebly.settings.parentVerticalPadding}}px {{settingsFromWeebly.settings.horizontalPadTabletParent || settingsFromWeebly.settings.parentHorizontalPadding}}px;
                    }
                    #{{childStyle.blockId}}{
                        max-width: {{childStyle.maxWidthTablet || childStyle.maxWidthDesktop}}%;
                        padding: {{childStyle.verticalPadPhone || childStyle.verticalPadTablet || childStyle.verticalPad}}px {{childStyle.horizontalPadTablet || childStyle.horizontalPad}}px;
                        {{childStyle.borderGeneralWidthTablet && !childStyle.useIndividualBorder ? 'border-width:'+childStyle.borderGeneralWidthTablet+'px;':''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderTopWidthTablet ?
                        'border-top-width:' + childStyle.borderTopWidthTablet +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderRightWidthTablet ?
                        'border-right-width:' + childStyle.borderRightWidthTablet +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderBottomWidthTablet ?
                        'border-bottom-width:' + childStyle.borderBottomWidthTablet +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderLeftWidthTablet ?
                        'border-left-width:' + childStyle.borderLeftWidthTablet +'px;' : ''}}
                    }
                    .blocks-flex-parent-wrap {
                        {{!settingsFromWeebly.settings.useIndividualBorder &&  settingsFromWeebly.settings.borderGeneralWidthTabletParent ? 'border-width:'+settingsFromWeebly.settings.borderGeneralWidthTabletParent+'px;':''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderTopWidthTabletParent ?
                        'border-top-width:' + settingsFromWeebly.settings.borderTopWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderRightWidthTabletParent ?
                        'border-right-width:' + settingsFromWeebly.settings.borderRightWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderBottomWidthTabletParent ?
                        'border-bottom-width:' + settingsFromWeebly.settings.borderBottomWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderLeftWidthTabletParent ?
                        'border-left-width:' + settingsFromWeebly.settings.borderLeftWidthTabletParent +'px;' : ''}}
                    }
                    .hide-child-block-tablet::before {
                        font-family: "Font Awesome 5 Free";
                        content: "\f070";
                        font-size: 12px;
                        line-height: 40px;
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        text-align: center;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        font-weight: 400;
                        border: 1px solid #E7003E;
                        color: #E7003E;
                        background: #fff;
                    }
                </vstyle>
            </div>

            <div v-if="deviceStylesSetttings.mobileStyles">
                <vstyle v-for="(childStyle, index) in childBlocksArray" :key="index">
                    #{{settingsFromWeebly.settings.flexParentId}}{
                        padding: {{settingsFromWeebly.settings.verticalPadPhoneParent || settingsFromWeebly.settings.verticalPadTabletParent || settingsFromWeebly.settings.parentVerticalPadding}}px {{settingsFromWeebly.settings.horizontalPadPhoneParent || settingsFromWeebly.settings.horizontalPadTabletParent || settingsFromWeebly.settings.parentHorizontalPadding}}px;
                    }
                    #{{childStyle.blockId}}{
                        max-width: {{childStyle.maxWidthPhone || childStyle.maxWidthTablet || childStyle.maxWidthDesktop}}%;
                        padding: {{childStyle.verticalPadPhone || childStyle.verticalPadTablet || childStyle.verticalPad}}px {{childStyle.horizontalPadPhone || childStyle.horizontalPadTablet || childStyle.horizontalPad}}px;
                        {{childStyle.borderGeneralWidthPhone && !childStyle.useIndividualBorder ? 'border-width:'+childStyle.borderGeneralWidthPhone+'px;':''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderTopWidthPhone ?
                        'border-top-width:' + childStyle.borderTopWidthPhone +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderRightWidthPhone ?
                        'border-right-width:' + childStyle.borderRightWidthPhone +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderBottomWidthPhone ?
                        'border-bottom-width:' + childStyle.borderBottomWidthPhone +'px;' : ''}}
                        {{ childStyle.useIndividualBorder && childStyle.borderLeftWidthPhone ?
                        'border-left-width:' + childStyle.borderLeftWidthPhone +'px;' : ''}}
                    }
                    .blocks-flex-parent-wrap {
                        {{!settingsFromWeebly.settings.useIndividualBorder &&  settingsFromWeebly.settings.borderGeneralWidthPhoneParent ? 'border-width:'+settingsFromWeebly.settings.borderGeneralWidthPhoneParent+'px;':''}}
                        {{!settingsFromWeebly.settings.useIndividualBorder &&  !settingsFromWeebly.settings.borderGeneralWidthPhoneParent && settingsFromWeebly.settings.borderGeneralWidthTabletParent ? 'border-width:'+settingsFromWeebly.settings.borderGeneralWidthTabletParent+'px;':''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderTopWidthPhoneParent ?
                        'border-top-width:' + settingsFromWeebly.settings.borderTopWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && !settingsFromWeebly.settings.borderTopWidthPhoneParent && settingsFromWeebly.settings.borderTopWidthTabletParent ?
                        'border-top-width:' + settingsFromWeebly.settings.borderTopWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderRightWidthPhoneParent ?
                        'border-right-width:' + settingsFromWeebly.settings.borderRightWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && !settingsFromWeebly.settings.borderRightWidthPhoneParent && settingsFromWeebly.settings.borderRightWidthTabletParent ?
                        'border-right-width:' + settingsFromWeebly.settings.borderRightWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderBottomWidthPhoneParent ?
                        'border-bottom-width:' + settingsFromWeebly.settings.borderBottomWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && !settingsFromWeebly.settings.borderBottomWidthPhoneParent && settingsFromWeebly.settings.borderBottomWidthTabletParent ?
                        'border-bottom-width:' + settingsFromWeebly.settings.borderBottomWidthTabletParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.borderLeftWidthPhoneParent ?
                        'border-left-width:' + settingsFromWeebly.settings.borderLeftWidthPhoneParent +'px;' : ''}}
                        {{ settingsFromWeebly.settings.useIndividualBorder && !settingsFromWeebly.settings.borderLeftWidthPhoneParent && settingsFromWeebly.settings.borderLeftWidthTabletParent ?
                        'border-left-width:' + settingsFromWeebly.settings.borderLeftWidthTabletParent +'px;' : ''}}
                    }
                    .hide-child-block-phone::before {
                        font-family: "Font Awesome 5 Free";
                        content: "\f070";
                        font-size: 12px;
                        line-height: 40px;
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        text-align: center;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        font-weight: 400;
                        border: 1px solid #E7003E;
                        color: #E7003E;
                        background: #fff;
                    }
                </vstyle>
            </div>
            <!-- <div v-for="(childStyle) in childBlocksArray" :key="childStyle.blockId">
                
                <vscript v-if="childStyle.useParallax">
                (function($) {
                    $(function() {
                        $('#{{childStyle.blockId}}').jarallax({
                            speed: {{childStyle.parallaxSpeed}},
                            imgPosition: '{{childStyle.xAxisPosition+' '+childStyle.yAxisPosition}}'
                        });
                    })
                }(jQuery));
                
                </vscript>
            </div> -->

        </div>

    </div>

</template>

<script>

import BlocksChild from './elementSettings/blocks/BlocksChild'
import draggable from 'vuedraggable'
import axios from 'axios'

export default {
    name: 'Blocks',

    data() {
        return {
            parentBlocksId: 'flexparent-'+Math.random().toString(36).substr(2, 16),
            selectedFile : null,
            imageBg: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg'
        }
    },

    components: {
        BlocksChild,
        draggable,

        'vstyle': {
            render: function (createElement) {

                return createElement('style', this.$slots.default)
                
            }
        },

        'vscript': {
            render: function (createElement) {

                return createElement('script', this.$slots.default)
                
            }
        }
    },

    methods: {

        addToChildArray() {

            console.log(this.$store.state.weeblySettings.settings.childBlocks);

            // this.removeActiveFromBlock()

            this.$store.state.weeblySettings.settings.childBlocks.push(
                {
                    blockId: 'blocks-flexchild-'+Math.random().toString(36).substr(2, 16),
                    childBackground: '#f1f1f1',
                    maxWidthDesktop: '100',
                    maxWidthTablet: null,
                    maxWidthPhone: null,
                    hideOnDesktop: false,
                    hideOnTablet: false,
                    hideOnPhone: false,
                    horizontalPad: 15,
                    verticalPad: 15,
                    horizontalPadTablet: null,
                    verticalPadTablet: null,
                    horizontalPadPhone: null,
                    verticalPadPhone: null,

                    borderGeneralColor: '#cccccc',
                    borderGeneralStyle: 'solid',
                    borderGeneralWidth: 1,

                    useIndividualBorder: false,

                    borderTopColor: '#cccccc',
                    borderTopStyle: 'solid',
                    borderTopWidth: 1,
                    
                    borderRightColor: '#cccccc',
                    borderRightStyle: 'solid',
                    borderRightWidth: 1,
                    
                    borderBottomColor: '#cccccc',
                    borderBottomStyle: 'solid',
                    borderBottomWidth: 1,
                    
                    borderLeftColor: '#cccccc',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 1,

                    borderGeneralWidthTablet: null,
                    borderTopWidthTablet: null,
                    borderRightWidthTablet: null,
                    borderBottomWidthTablet: null,
                    borderLeftWidthTablet: null,

                    borderGeneralWidthPhone: null,
                    borderTopWidthPhone: null,
                    borderRightWidthPhone: null,
                    borderBottomWidthPhone: null,
                    borderLeftWidthPhone: null,

                    useIndividualBorderRadius: false,

                    borderRadiusGeneral: 0,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,

                    backgroundColorChild: true,
                    backgroundImageChild: false,
                    backgroundImageChildSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',
                    useBackgroundVideo: false,
                    backgroundVideoUrl: 'https://www.youtube.com/watch?v=-SJXOTtdTDE&list=PLx-qGAzjv13c00FYZMLAJm65WjsT3ZmDR&index=3',
                    xAxisPosition: 'center',
                    yAxisPosition: 'center',
                    useParallax: true,
                    parallaxSpeed: 0.2,

                    useLink: false,
                    link: 'https://www.waddons.com',
                    target: '_blank'
                }
            )

            // add active class to newly added block
            // settings
            // let newActive = this.$store.state.weeblySettings.settings.childBlocks.length - 1
            // let newActiveClass = '.child-block-settings-'+this.$store.state.weeblySettings.settings.childBlocks[newActive].blockId
            // let newIdActive = this.$store.state.weeblySettings.settings.childBlocks[newActive].blockId

            // setTimeout(()=> {
            //     document.querySelector(newActiveClass).classList.add('active')
            //     document.getElementById(newIdActive).classList.add('active')
            // },1000)
            

            // settings

        },

        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--large i');
            icons.forEach(icon => {
                console.log(icon)
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.desktopStyles = true
            }

        }

    },

    computed:{


        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

        childBlocksArray: {
            get() {
                return this.$store.state.weeblySettings.settings.childBlocks
            },
            set(value) {
                console.log(value)
                // this.$store.commit('updateList', value)
                this.$store.state.weeblySettings.settings.childBlocks = value
            }
        }

    },

    mounted() {
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')

        console.log('weebly ',this.$store.state.weeblySettings)

    }
}
</script>

<style lang="less">

@import '../../less/colors.less';

.preview-box .bundle-element-setfullwidth {
    opacity: 1;
}

.flex-parent-handlers {
    position: absolute;
    height: 30px;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 3px 7px;
    border-radius: .25rem;
    border: 1px solid @border_grey_dark;
    opacity: 1!important;

    & > div {
        display: inline-block;
        width: 30px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border: 1px solid @border_grey_dark;
        cursor: pointer;

        i {
            color: @border_grey_dark;
            font-size: 12px;
        }

        i.fa-times {
            color: @warning_red;
        }
        i.fa-plus {
            color: @action_blue;
        }
    }
}

.flex-parent-handlers {
    position: absolute;
    height: 30px;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 3px 7px;
    border-radius: .25rem;
    border: 1px solid @border_grey_dark;

    & > div {
        display: inline-block;
        width: 30px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border: 1px solid @border_grey_dark;
        cursor: pointer;

        i {
            color: @border_grey_dark;
            font-size: 12px;
        }

        i.fa-times {
            color: @warning_red;
        }
        i.fa-plus {
            color: @action_blue;
        }
    }
}

.addChildBlock-btn {
    font-weight: 700;
    position: absolute;
    right: -75px;
    top: -9px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50%;
    padding: 0;
    margin: 0;
    font-size: 20px;
    box-shadow: 0 5px 17px fade(@spark_green, 60%);
    transition: all .3s ease-out;
    background: @spark_green;
    border: 0;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 7px 24px fade(@spark_green, 70%);
        background: fade(@spark_green, 90%)
    }
}

.blocks-action-bar-inline {
    display: inline-block;
    position: relative;
    margin: 10px auto 30px;
}

.block-child {
    display: block!important;
}

.block-with-video-bg {
    background: url(../../assets/videobg-placeholder.jpg) center/contain!important;
}

</style>





// WEBPACK FOOTER //
// src/components/elements/Blocks.vue